import React from 'react'
import Navbar from './Navb'
import './Navbar.css'
import Web from '../../Web'

const Navv = () => {
  return (
    <div className='onue'>
        
        <Navbar/>
      <Web/>
    </div>
  )
}

export default Navv
